import { fetchPersea } from "@/config/axios/config-axios";
import { GetAccountTargetSupportedSocialMediaParams } from "./types";
import { getJWTLocalStorage } from "@/utils/local-storage/user/local-storage";

export const getAccountTargetSupportedSocialMedia = async (params: GetAccountTargetSupportedSocialMediaParams) => {
    return await fetchPersea(`account-target/supported-social-media`, 'GET', params);
};

export async function sendTweet(message: string, image_url: string, campaign_id: number, mission_id: number) {
    try {
        const JWT = getJWTLocalStorage() ?? import.meta.env.VITE_X_API_KEY;
        
        const url = `${import.meta.env.VITE_URL_API}/social_media/twitter/tweet`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': `${JWT}`,
                'Accept': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                text: message,
                image_url: image_url,
                campaign_id: campaign_id,
                mission_id: mission_id
            })
        });

        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            const text = await response.text();
            console.error('Non-JSON response:', text);
            throw new Error('Invalid response format');
        }

        if (!response.ok) {
            const error = await response.json();
            console.error('Error response:', error); // Debug log
            throw new Error(error.error || 'Failed to tweet');
        }

        const result = await response.json();
        console.log('Tweet posted successfully:', result);
        return result;
    } catch (error) {
        console.error('Error posting tweet:', error);
        // Log more details about the error
        if (error instanceof Error) {
            console.error('Error name:', error.name);
            console.error('Error message:', error.message);
            console.error('Error stack:', error.stack);
        }
        throw error;
    }
}